(() => {
    /**
   * Component: Video Modal
   * -----------------------------------------------------------------------------
   */

  /**
   * Global variables.
   */
  const ACTIVE_CLASS = 'is-active';
  const LOCKED_CLASS = 'is-locked';

  /**
   * DOM selectors.
   */
  const selectors = {
    openModal: '[js-video-modal-trigger]',
    closeModal: '[js-video-modal-close]',
    videoModal: '[js-video-modal]',
    videoModalContent: '[js-video-modal-content]',
  };

  /**
   * DOM Node elements.
   */
  const nodeElements = {
    videoModal: document.querySelector(selectors.videoModal),
  };

  /**
   * Set Event listeners.
   *
   * @description Adds event listeners to open and close the video modal.
   */
  function setEventListeners() {
    document.body.addEventListener('click', (e) => {
      if (!nodeElements.videoModal) {
        return;
      }

      const openPopupTarget = e.target.closest(selectors.openModal);
      const closePopupTarget = e.target.closest(selectors.closeModal);
      const videoContentTarget = e.target.closest(selectors.videoModalContent);

      const isOpened = Boolean(
        nodeElements.videoModal.classList.contains(ACTIVE_CLASS)
      );

      if (openPopupTarget && !isOpened) {
        const dynamicVideoSrc =
          openPopupTarget.getAttribute('js-video-modal-src');
        const dynamicVideoElement =
          nodeElements.videoModal.querySelector('[js-video-media]');

        if (dynamicVideoSrc && dynamicVideoElement) {
          dynamicVideoElement.src = dynamicVideoSrc;
          dynamicVideoElement.play();
        }

        openModal();

        return;
      }

      /**
       * Close the modal when clicking on the close button or outside the modal.
       */
      if (
        isOpened &&
        (closePopupTarget || (!closePopupTarget && !videoContentTarget))
      ) {
        closeModal();
        return;
      }
    });
  }
  /**
   * Open the video modal.
   *
   * @description Adds the `is-active` class to display the modal.
   */
  function openModal() {
    nodeElements.videoModal?.classList.add(ACTIVE_CLASS);
    document.body.classList.add(LOCKED_CLASS);

    setScrollBarWidth();
  }

  /**
   * Close the video modal.
   *
   * @description Removes form errors and `is-active` class to hide the modal.
   */
  function closeModal() {
    nodeElements.videoModal?.classList.remove(ACTIVE_CLASS);
    document.body.classList.remove(LOCKED_CLASS);
  }

  function setScrollBarWidth() {
    /**
     * Set actual scrollbar width as a variable.
     * - This is used to apply as `margin-right` when body is scroll locked.
     * - This prevents the entire body shifting to the right when overlay appears.
     */
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;

    document.documentElement.style.setProperty(
      '--body-scroll-bar-width',
      `${scrollbarWidth}px`
    );
  }

  /**
   * Initialise component.
   */
  window.addEventListener('DOMContentLoaded', () => {
    setScrollBarWidth();
    setEventListeners();
  });
})();